import { API_ENDPOINT } from './config';

export const urlsErasmus = {
  erasmusApplications: `${API_ENDPOINT}/erasmus-applications`,
  erasmusApplicationsDetail: (id) =>
    `${API_ENDPOINT}/erasmus-applications/${id}`,
  erasmusApplicationsOrder: `${API_ENDPOINT}/erasmus-applications/order`,
  erasmusApplicationGenerateDocument: `${API_ENDPOINT}/generate-erasmus-word`,
  erasmusApplicationExcel: `${API_ENDPOINT}/generate-erasmus-excel`,
  erasmusUniversitiesExcel: `${API_ENDPOINT}/generate-erasmus-universities-excel`,
  erasmusApplicationPDF: `${API_ENDPOINT}/generate-erasmus-pdf`,
  erasmusApplicationStatus: `${API_ENDPOINT}/post-erasmus-status`,
  applicationStatusStack: `${API_ENDPOINT}/erasmus-status-stack`,
  erasmusPrivateFileDownload: (id, filename) =>
    `${API_ENDPOINT}/erasmus-private-file-download/${id}/${filename}`,
  erasmusUniversities: `${API_ENDPOINT}/erasmus-universities`,
  erasmusUniversityDetail: (id) => `${API_ENDPOINT}/erasmus-universities/${id}`,
  universitiesStack: `${API_ENDPOINT}/universitiesStack`,
  erasmusMobilities: `${API_ENDPOINT}/erasmus-mobilities`,
  erasmusMobilityDetail: (id) => `${API_ENDPOINT}/erasmus-mobilities/${id}`,
  erasmusMobilityPrivateFileDownload: (id, filename) =>
    `${API_ENDPOINT}/erasmus-mobility-private-file-download/${id}/${filename}`,
  erasmusMobilityTypes: `${API_ENDPOINT}/erasmus-mobility-types`,
  erasmusMobilitySubtypes: `${API_ENDPOINT}/erasmus-mobility-subtypes`,
  erasmusConsortiums: `${API_ENDPOINT}/erasmus-consortium`,
  erasmusConsortiumDetail: (id) => `${API_ENDPOINT}/erasmus-consortium/${id}`,
  createConsortiumsUniversities: `${API_ENDPOINT}/erasmus-consortium/universities/create`,
  deleteConsortiumsUniversities: id => `${API_ENDPOINT}/erasmus-consortium/universities/delete/${id}`,
  erasmusChallenges: `${API_ENDPOINT}/erasmus-challenges`,
  erasmusChallengeDetail: id => `${API_ENDPOINT}/erasmus-challenges/${id}`,
  erasmusSubjects: `${API_ENDPOINT}/erasmus-subjects`,
  erasmusSubjectDetail: (id) => `${API_ENDPOINT}/erasmus-subjects/${id}`,
  erasmusQuestionnaire: `${API_ENDPOINT}/erasmus-questionnaire`,
  erasmusQuestionnaireDetail: (id) =>
    `${API_ENDPOINT}/erasmus-questionnaire/${id}`,
  erasmusQuestionnaireByMobilityId: (id) =>
    `${API_ENDPOINT}/erasmus-questionnaire/mobility/${id}`,
};

export const routesErasmus = {
  cmsErasmusDashboard: '/cms/erasmus/dashboard',
  cmsErasmusApplication: '/cms/erasmus/applications',
  cmsErasmusApplicationCreate: '/cms/erasmus/applications/create',
  cmsErasmusApplicationEdit: '/cms/erasmus/applications/edit',
  cmsErasmusApplicationOrder: '/cms/erasmus/applications/order',
  cmsErasmusApplicationArchive: '/cms/erasmus/archive',
  cmsErasmusUniversity: '/cms/erasmus/universities',
  cmsErasmusUniversityCreate: '/cms/erasmus/universities/create',
  cmsErasmusUniversityEdit: '/cms/erasmus/universities/edit',
  cmsErasmusConsortium: '/cms/erasmus/consortium',
  cmsErasmusConsortiumCreate: '/cms/erasmus/consortium/create',
  cmsErasmusConsortiumEdit: '/cms/erasmus/consortium/edit',
  cmsErasmusChallenges: '/cms/erasmus/challenges',
  cmsErasmusChallengesCreate: '/cms/erasmus/challenges/create',
  cmsErasmusChallengesEdit: '/cms/erasmus/challenges/edit',
  cmsErasmusSubjects: '/cms/erasmus/subjects',
  cmsErasmusSubjectsCreate: '/cms/erasmus/subjects/create',
  cmsErasmusSubjectsEdit: '/cms/erasmus/subjects/edit',
  cmsErasmusMobility: '/cms/erasmus/mobility',
  cmsErasmusMobilityCreate: '/cms/erasmus/mobility/create',
  cmsErasmusMobilityEdit: '/cms/erasmus/mobility/edit',
  cmsErasmusMobilityQuestionnaire: '/cms/erasmus/mobility/questionnaire',
  cmsErasmusMobilityQuestionnaireCreate:
    '/cms/erasmus/mobility/questionnaire/create',
  cmsErasmusMobilityQuestionnaireEdit:
    '/cms/erasmus/mobility/questionnaire/edit',
};
